export default {
    props: {
        tags: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            address: "https://www.yourdictionary.com/articles/"
        };
    },
    methods: {
        makeSlug(str) {
            return str
                .trim()
                .toLowerCase()
                .replace(" ", "-");
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/ArticleTags/ArticleTags.js